import { GraphQLFetchPolicy } from '@getaccept/lib-shared/src/graphql/graphql-fetch-policy';
import { apolloClient } from '../../apollo';
import { VideoQueries } from './graphql/video.queries';

export class VideoService {
  static async load(id: string): Promise<{ videoUrl: string; thumbUrl: string }> {
    const {
      data: {
        getVideo: { videoUrl, thumbUrl },
      },
    } = await apolloClient.query({
      query: VideoQueries.load,
      variables: { id },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return { videoUrl, thumbUrl };
  }

  static async loadThumbnail(id: string): Promise<string> {
    const {
      data: {
        getVideo: { thumbUrl },
      },
    } = await apolloClient.query({
      query: VideoQueries.loadThumbnail,
      variables: { id },
      fetchPolicy: GraphQLFetchPolicy.NetworkOnly,
    });
    return thumbUrl;
  }
}
